/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
import {
  WORKSPACE_EPOCH_KEY, WORKSPACE_SIGN_OUT_EVENT, parseWorkspaceNotice, type WorkspaceNotice,
} from '../components/shared/workspace-notice.contract';
export {
  WORKSPACE_EPOCH_KEY, WORKSPACE_CHANNEL, WORKSPACE_CONTEXT_CHANGED_EVENT,
  WORKSPACE_SIGN_OUT_EVENT, parseWorkspaceNotice, type WorkspaceNotice,
} from '../components/shared/workspace-notice.contract';
export function readWorkspaceNotice(): string | null {
  try { return localStorage.getItem(WORKSPACE_EPOCH_KEY); } catch { return null; }
}
export function publishWorkspaceNotice(notice: WorkspaceNotice, channel: BroadcastChannel | null): void {
  const value = `${notice.epoch}:${notice.phase}`;
  // Only an opaque lifecycle marker is stored. No tenant, actor, cookie or cached response.
  try { localStorage.setItem(WORKSPACE_EPOCH_KEY, value); } catch { /* BroadcastChannel remains available. */ }
  channel?.postMessage(value);
}

/** Sign-out is a terminal lifecycle boundary, never a workspace selection. */
export function publishWorkspaceSignOut(): void {
  publishWorkspaceNotice({ epoch: crypto.randomUUID(), phase: 'signed-out' }, null);
  window.dispatchEvent(new Event(WORKSPACE_SIGN_OUT_EVENT));
}

/** Only a successful, explicit credential/MFA response can reopen entry. */
export function clearWorkspaceSignOutNotice(): void {
  if (parseWorkspaceNotice(readWorkspaceNotice())?.phase !== 'signed-out') return;
  try { localStorage.removeItem(WORKSPACE_EPOCH_KEY); } catch { /* Runtime state remains authoritative. */ }
}
